import * as Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import HighchartsStock from "highcharts/highstock"
import highchartsMore from "highcharts/highcharts-more.js"
import solidGauge from "highcharts/modules/solid-gauge.js"

highchartsMore(Highcharts)
solidGauge(Highcharts)

export const defaultOptions: Highcharts.Options = {
	exporting: {
		enabled: false,
	},
	credits: { enabled: false },
	chart: {
		style: {
			fontFamily: `system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial ,sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji'`,
		},
	},
}

export const miniOptions: Highcharts.Options = {
	chart: {
		height: 150,
		spacing: [0, 0, 0, 0],
		plotBorderWidth: 0,
	},
	legend: {
		enabled: false,
	},
	tooltip: {
		enabled: false,
	},
	title: {
		text: "",
	},
	yAxis: {
		visible: false,
	},
}

export const Highchart = (props: HighchartsReact.Props) => {
	return <HighchartsReact highcharts={Highcharts} {...props} />
}

export const Stockchart = (props: HighchartsReact.Props) => {
	return (
		<HighchartsReact
			constructorType="stockChart"
			highcharts={HighchartsStock}
			{...props}
		/>
	)
}

export { Highcharts, HighchartsReact }
